import { render, staticRenderFns } from "./MainCardPicture.vue?vue&type=template&id=029fba62&scoped=true&"
import script from "./MainCardPicture.vue?vue&type=script&lang=js&"
export * from "./MainCardPicture.vue?vue&type=script&lang=js&"
import style0 from "./MainCardPicture.vue?vue&type=style&index=0&id=029fba62&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029fba62",
  null
  
)

export default component.exports